import React from 'react';
import { connect } from 'dva';
import MeetingControl from '../components/meetingControl/MeetingControl';
import { injectIntl } from 'react-intl';

export default connect(state => {
  return {
    ...state,
    loading: state.loading.global
  };
})(
  injectIntl(({ meetingControl, loading, intl, dispatch }) => {
    return (
      <MeetingControl
        intl={intl}
        loading={loading}
        dispatch={dispatch}
        meetingControl={meetingControl}
      />
    );
  })
);



// WEBPACK FOOTER //
// ./src/routes/MeetingControl.js